import React from 'react'

import { Link, LINK_VARIANT_HIGHLIGHT } from 'mailup-web-components'

const TAGS_WHITELIST = ['div', 'p', 'span', 'strong', 'em', 'i', 'b', 'u']

const safeTagName = (t) => {
  const toLower = t.toLowerCase()
  return TAGS_WHITELIST.includes(toLower) ? toLower : 'span'
}

const safeNode = (n) => {
  switch (n.nodeType) {
    case 1: // element
      if (n.tagName.toLowerCase() === 'extlink') {
        return (
          <Link
            variant={LINK_VARIANT_HIGHLIGHT}
            href={n.textContent}
            target='_blank'
            rel='noopener noreferrer'
          >
            {n.textContent}
          </Link>
        )
      } else {
        return React.createElement(
          safeTagName(n.tagName),
          null,
          safeNodes(n.childNodes)
        )
      }

    case 3: //  text
      return n.textContent
  }
}

const safeNodes = (children) => {
  const x = Array.from(children)

  return <>{x.map((x) => safeNode(x))}</>
}

const safeHtml = (str) => {
  if (!str) return null
  //
  try {
    const doc = new DOMParser().parseFromString(str, 'text/html')
    //
    return safeNodes(doc.body.childNodes)
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('### error', error)
  }
  return null
}

export default safeHtml
